var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H3.41399L7.70699 1.707C8.09699 1.317 8.09699 0.683997 7.70699 0.292997C7.31699 -0.0980028 6.68399 -0.0970028 6.29299 0.292997L0.292988 6.293C-0.0970117 6.683 -0.0970117 7.316 0.292988 7.707L6.29299 13.707C6.48799 13.902 6.74299 14 6.99999 14C7.25699 14 7.51199 13.902 7.70699 13.707C8.09699 13.317 8.09699 12.684 7.70699 12.293L3.41399 8H16C16.553 8 17 7.553 17 7C17 6.447 16.553 6 16 6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.8e927eeaf08d2f5f48860a68b33a8516.svg";
export { ForwardRef as ReactComponent };